/* eslint-disable camelcase */
import { get, post } from '../apiHelper';

/**
 * Fetch the current audit quota for the requesting IP / email.
 * @param {string} [email] - Optional email to include in the quota check.
 */
export async function fetchAuditQuota(email) {
  const params = email ? { email } : undefined;
  const response = await get({ path: 'yt-audit/quota', version: 'gateway', params });
  return response.json();
}

/**
 * Create a new YouTube channel audit.
 * @param {string} channelUrl - The YouTube channel URL to audit.
 * @param {string} [email]    - Optional creator email.
 */
export async function createAudit(channelUrl, email) {
  const body = { channel_url: channelUrl };
  if (email) body.email = email;
  const response = await post({ path: 'yt-audit', version: 'gateway', body });
  return response.json();
}

/**
 * Fetch the current state of an audit by ID.
 * @param {string} auditId
 */
export async function fetchAudit(auditId) {
  const response = await get({ path: `yt-audit/${auditId}`, version: 'gateway' });
  return response.json();
}

/**
 * Request a re-run of a previously completed or failed audit.
 * @param {string} auditId
 */
export async function rerunAudit(auditId) {
  const response = await post({ path: `yt-audit/${auditId}/rerun`, version: 'gateway', body: {} });
  return response.json();
}

/**
 * Fetch aggregated platform stats for the Creator Satellite landing page.
 */
export async function fetchPlatformStats() {
  const response = await get({ path: 'yt-audit/platform-stats', version: 'gateway' });
  return response.json();
}

/**
 * Save an email address against a completed audit and send the PDF report.
 * @param {string} auditId
 * @param {string} email
 */
export async function notifyAuditEmail(auditId, email) {
  await post({ path: `yt-audit/${auditId}/notify-email`, version: 'gateway', body: { email } });
}

/**
 * Fetch the PDF report for a completed audit and trigger a browser download.
 * @param {string} auditId
 */
export async function fetchAuditPdf(auditId) {
  const response = await get({ path: `yt-audit/${auditId}/pdf`, version: 'gateway' });
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `redflag-audit-${auditId}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
